import { CancelIcon } from "../../assets/icons/icon-assets";
import { Pressable } from "native-base";
import React, { FC } from "react";

interface Props {
  callback: any | undefined;
  color: string | undefined;
  hoverColor?: string;
  size: any | undefined;
  disabled?: boolean;
}

const AVCancel: FC<Props> = ({
  callback,
  color = "AVColor.black",
  hoverColor = "AVColor.grey",
  size = "30px",
  disabled = false,
}) => {
  return (
    <Pressable
      _hover={{
        bgColor: hoverColor,
        rounded: "full",
      }}
      onPress={() => {
        callback(false);
      }}
      zIndex={1}
      disabled={disabled}
      opacity={disabled ? 0.5 : 1}
    >
      <CancelIcon size={size} color={color} />
    </Pressable>
  );
};

export default AVCancel;
